export interface IncidentsActivityPanelWebComponentSchema {
  // all the data needed for rendering
}

export enum KillChainPhases {
  INITIAL_ACCESS = 1,
  EXECUTION = 2,
  PERSISTENCE = 3,
  PRIVILEGE_ESCALATION = 4,
  DEFENCE_EVASION = 5,
  CREDENTIAL_ACCESS = 6,
  DISCOVERY = 7,
  LATERAL_MOVEMENT = 8,
  COLLECTION = 9,
  COMMAND_AND_CONTROL = 10,
  EXFILTRATION = 11,
  IMPACT = 12
}

export const KillChainPhasesOrdered = [
  KillChainPhases.INITIAL_ACCESS,
  KillChainPhases.EXECUTION,
  KillChainPhases.PERSISTENCE,
  KillChainPhases.PRIVILEGE_ESCALATION,
  KillChainPhases.DEFENCE_EVASION,
  KillChainPhases.CREDENTIAL_ACCESS,
  KillChainPhases.DISCOVERY,
  KillChainPhases.LATERAL_MOVEMENT,
  KillChainPhases.COLLECTION,
  KillChainPhases.COMMAND_AND_CONTROL,
  KillChainPhases.EXFILTRATION,
  KillChainPhases.IMPACT
];

export enum GroupBy {
  TIMELINE = 'timeline',
  KILLCHAIN_PHASE = 'killchainPhase',
  SEVERITY = 'severity',
  SENSOR = 'sensor',
  INCIDENT_ID = 'incidentId',
  NODE = 'node',
  ALERT_NAME = 'alertName',
}

export enum ActivityEvents {
  VIEW_MORE_DETAILS = 'viewMoreDetails',
  VIEW_NODE_DETAILS = 'viewNodeDetails',
  CHANGE_GROUP_BY = 'changeGroupBy',
  COLLAPSE_PANEL = 'collapsePanel',
}

export enum Severity {
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
  INFO = 4
}
